/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAnalytics
 */
export interface GoogleAnalytics {
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalytics
     */
    trackingCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAnalytics
     */
    trackingCodeV4?: string;
}

export function GoogleAnalyticsFromJSON(json: any): GoogleAnalytics {
    return {
        'trackingCode': !exists(json, 'trackingCode') ? undefined : json['trackingCode'],
        'trackingCodeV4': !exists(json, 'trackingCodeV4') ? undefined : json['trackingCodeV4'],
    };
}

export function GoogleAnalyticsToJSON(value?: GoogleAnalytics): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'trackingCode': value.trackingCode,
        'trackingCodeV4': value.trackingCodeV4,
    };
}


